
function PaginationComponent({ total, limit, currentPage, onPageChange }) {
  const totalPages = Math.ceil(total / limit);

  const handlePageChange = (pageNumber) => {

    onPageChange(pageNumber);
  };

  if (totalPages <= 1) {
    return null;
  }

  const paginationItems = [];
  let endPage;
  const dots = 8;

  if (totalPages <= dots) {
    endPage = totalPages;
  } else {
    endPage = dots;
  }

  // 創建分頁按鈕
  for (let number = 1; number <= endPage; number++) {
    paginationItems.push(
      <div
        key={number}
        className={`bg-primary mb-0 dot ${number === currentPage ? 'active' : ''}`}
        onClick={() => handlePageChange(number)}
      ></div>
    );
  }

  return (
    <div className="d-flex justify-content-center gap-2 px-3">
      {paginationItems}
    </div>
  );
}

export default PaginationComponent;
